<template>
	<div class="grid grid-cols-1 gap-2 md:grid-cols-3">
		<div
			v-for="region in Array.from({ length: 15 }).keys()"
			:key="region"
			class="relative flex items-center gap-2 p-2 pr-8 text-sm font-bold rounded-md bg-light-50 dark:bg-dark-800"
		>
			<UiSkeleton class="w-6 h-6 rounded-full bg-light-400 dark:bg-dark-400" />
			<UiSkeleton class="w-[150px] h-3 bg-light-400 dark:bg-dark-400" />
		</div>
	</div>
</template>
